export enum QuestionnaireLanguageCode {
  En = "en",
  Sv = "sv",
}
